import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { APP_RUNTIME_CONFIG } from '@core/auth/app-config.model';

import { CreateDivisionDto, DivisionDto, UpdateDivisionDto } from './divisions.dto';

/**
 * Divisions — `/api/v1/divisions`, keyed by CODE rather than a guid.
 *
 * The one catalogue that did not move to guids, deliberately: a division code is
 * quoted by the business, so it is the identity as well as the handle.
 */
@Injectable({ providedIn: 'root' })
export class DivisionsApiService {
  private readonly http = inject(HttpClient);
  private readonly config = inject(APP_RUNTIME_CONFIG);

  /** Whether a backend is configured. Empty `apiUrl` = the seeded prototype. */
  available(): boolean {
    return !!this.config.apiUrl;
  }

  private url(path = ''): string {
    return `${this.config.apiUrl.replace(/\/$/, '')}/divisions${path}`;
  }

  listDivisions(): Observable<DivisionDto[]> {
    return this.http.get<DivisionDto[]>(this.url());
  }

  createDivision(body: CreateDivisionDto): Observable<DivisionDto> {
    return this.http.post<DivisionDto>(this.url(), body);
  }

  /**
   * Replace one whole. The path carries the code as it stands NOW; the body may
   * change it, which is how a division is renumbered.
   */
  replaceDivision(code: string, body: UpdateDivisionDto): Observable<DivisionDto> {
    return this.http.put<DivisionDto>(this.url(`/${encodeURIComponent(code)}`), body);
  }

  /** Retire one. SOFT — four modules point at divisions. Answers 204. */
  retireDivision(code: string): Observable<void> {
    return this.http.delete<void>(this.url(`/${encodeURIComponent(code)}`));
  }
}
